import React from 'react';
import { CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import LinkedInDashboard from './pages/LinkedInDashboard';
import ProfilePage from './pages/ProfilePage';
import UsefulLinks from './pages/UsefulLinks';
import AuthTokenCallback from './components/AuthTokenCallback';
import UnauthorizedPage from './pages/UnauthorizedPage';
import Navbar from './components/Navbar';
import './App.css';
import Admin from './pages/Admin';
import Colleagues from './components/Colleagues';
import BlogPage from './pages/BlogPage';

// Layout for protected routes to render under the Navbar

function ProtectedLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}


function App() {
  return (
    <div className="App">
      <CssBaseline />
      <Router>
        <Routes>
          {/* Unprotected routes (render without Navbar) */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthTokenCallback />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />

          {/* Protected routes (render under Navbar) */}
          <Route
            element={<ProtectedLayout />}
          >
            <Route path="/home" element={<LinkedInDashboard />} />
            <Route path="/old-dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/links" element={<UsefulLinks />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/colleagues" element={<Colleagues />} />
            <Route path="/blog" element={<BlogPage />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
